"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.startInterview = exports.sendAnswersToMetrika = exports.scrollToElement = void 0;
__exportStar(require("./events"), exports);
__exportStar(require("./pages"), exports);
__exportStar(require("./questions"), exports);
__exportStar(require("./requests"), exports);
__exportStar(require("./survey"), exports);
const scrollToElement = (elementId, componentType = 'question') => {
    return {
        type: 'SCROLL_TO_ELEMENT',
        elementId,
        componentType
    };
};
exports.scrollToElement = scrollToElement;
const sendAnswersToMetrika = () => {
    return {
        type: 'METRIKA_SEND_ANSWERS'
    };
};
exports.sendAnswersToMetrika = sendAnswersToMetrika;
const startInterview = ({ _ivid, _uid }) => {
    return {
        type: 'INTERVIEW_STARTED',
        data: {
            _uid,
            _ivid
        }
    };
};
exports.startInterview = startInterview;
